package ui.theme

import org.jetbrains.compose.web.css.*

object AppShapes {
    // Border Radius Values
    val none = 0.px
    val sm = 4.px
    val md = 8.px
    val lg = 12.px
    val xl = 16.px
    val xl2 = 20.px
    val xl3 = 24.px
    val full = 9999.px
    
    // Specific Shape Definitions
    val cardRadius = xl2          // 20px for cards
    val buttonRadius = xl         // 16px for buttons
    val inputRadius = lg          // 12px for inputs
    val modalRadius = xl2         // 20px for modals
    val avatarRadius = full       // fully rounded for avatars
    val chipRadius = full         // fully rounded for chips/tags
    
    // Animation Curves
    val easeInOut = "cubic-bezier(0.4, 0, 0.2, 1)"
    val easeOut = "cubic-bezier(0, 0, 0.2, 1)"
    val easeIn = "cubic-bezier(0.4, 0, 1, 1)"
    val easeLinear = "linear"
    val easeSpring = "cubic-bezier(0.16, 1, 0.3, 1)"
    val easeElastic = "cubic-bezier(0.23, 1, 0.32, 1)"
    val easeBounce = "cubic-bezier(0.68, -0.55, 0.265, 1.55)"
    
    // Animation Durations
    val durationFast = 150.ms
    val durationNormal = 300.ms
    val durationSlow = 500.ms
    val durationSlower = 700.ms
    
    // Z-Index Layers
    val zBase = 0
    val zDropdown = 1000
    val zSticky = 1020
    val zFixed = 1030
    val zModal = 1040
    val zPopover = 1050
    val zTooltip = 1060
    val zToast = 1070
}
